import { ApiValidationError } from 'client/types/errors';

import { FormErrors } from '../hocs/types';
import { SmartHomeValidationStatuses } from '../model/draft';
import { GrammarValidationErrorPayload } from '../model/grammar';
import { AnyFormSettings } from '../types';

export type ErrorPayload = {
    errorCode?: string | number;
    typedErrors?: ApiValidationError[];
    statuses?: SmartHomeValidationStatuses;
};

type ApiErrorFields = FormErrors<AnyFormSettings>;

export interface ApiErrorType {
    name: string;
    message: string;
    code: number;
    fields?: ApiErrorFields;
    payload?: ErrorPayload;
}

interface ApiErrorParams<T extends ErrorPayload = ErrorPayload> {
    code: number;
    payload?: T;
    fields?: ApiErrorFields;
}

export class ApiError<T extends ErrorPayload = ErrorPayload> extends Error {
    public code: number;
    public fields?: ApiErrorFields;
    public payload?: T;

    constructor(
        public message: string,
        params: ApiErrorParams<T>,
    ) {
        super(message);

        this.code = params.code;
        this.fields = params.fields;
        this.payload = params.payload;

        // Extending built-ins like Error, Array, and Map not working since 2.2
        // @see https://github.com/Microsoft/TypeScript/issues/13965
        Object.setPrototypeOf(this, ApiError.prototype);
    }

    public isGrammarValidationError = (): this is ApiError<GrammarValidationErrorPayload> => {
        return this.payload?.errorCode === 'VALIDATION_ERROR';
    };

    public isCustomEntityInUseError = () => {
        return this.payload?.errorCode === 'ENTITY_IN_USE';
    };

    public isDuplicateIntentIdError = () => {
        return this.payload?.errorCode === 'INTENT_ID_ALREADY_EXISTS';
    };
}
